const formElement = document.getElementById('posted_successful_form');
const closeModalButton = document.querySelector('.close-modal');
function toggleScrolling() {
  if (formElement?.classList.contains('posted-successful-form')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}
toggleScrolling();
closeModalButton?.addEventListener('click', function () {
  formElement.classList.remove('posted-successful-form');
  toggleScrolling();
  formElement.classList.add('hidden');
});
window.onclick = function (event) {
  if (event.target == formElement) {
    formElement.classList.remove('posted-successful-form');
    document.body.style.overflow = "auto"; 
  }
};